import { dispatch } from "../store/dispatch";
import { useBooks } from "../store/useBooks";
import { useConn } from "../store/useConn";
import { TradingSocket } from "./ws";

/**
 * Торговый сокет — синглтон модуля, а не React-контекст.
 *
 * Сокет живёт столько же, сколько вкладка, ровно как операторский токен в
 * token.ts. Провайдер, создающий его в эффекте, в StrictMode проходит
 * connect -> close -> connect на каждом монтировании, а при переходе между
 * страницами размонтирование одного потребителя рвало бы соединение остальным.
 */
export const socket = new TradingSocket({
  onMessage: dispatch,
  onState: (state) => {
    useConn.getState().setConnection(state);
    if (state !== "open") {
      // Пока связи нет, дельты теряются по определению — «подтверждён» на
      // лесенке был бы уверенной ложью.
      useBooks.getState().markAllStale();
    }
  },
});

let started = false;

/** Идемпотентный запуск: в StrictMode эффект вызывается дважды. */
export function startSocket(): void {
  if (started) return;
  started = true;
  socket.connect();
}

// Горячая перезагрузка модуля в dev иначе оставляла бы висящее соединение, и
// через десяток правок web_api насчитал бы десяток операторов.
import.meta.hot?.dispose(() => {
  started = false;
  socket.close();
});
